
/**
 * @sveltech/routify 1.9.10
 * File generated Wed Apr 23 2025 22:30:00 GMT+0200 (czas środkowoeuropejski letni)
 */

export const __version = "1.9.10"
export const __timestamp = "2025-04-23T20:30:00.122Z"

//buildRoutes
import { buildClientTree } from "@sveltech/routify/runtime/buildRoutes"

//imports


//options
export const options = {}

//tree
export const _tree = {
  "name": "root",
  "filepath": "/",
  "root": true,
  "ownMeta": {},
  "absolutePath": "src/pages",
  "children": [
    {
      "isFile": true,
      "isDir": false,
      "ext": "svelte",
      "isLayout": true,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/",
      "id": "__layout",
      "component": () => import('../../../../src/pages/_layout.svelte').then(m => m.default)
    },
    {
      "isFile": true,
      "isDir": false,
      "ext": "svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": true,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/about",
      "id": "_about",
      "component": () => import('../../../../src/pages/about.svelte').then(m => m.default)
    },
    {
      "isFile": false,
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": true,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/blog/index",
          "id": "_blog_index",
          "component": () => import('../../../../src/pages/blog/index.svelte').then(m => m.default)
        },
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": true,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/blog/psychoterapia-psychodynamiczna/index",
              "id": "_blog_psychoterapiaPsychodynamiczna_index",
              "component": () => import('../../../../src/pages/blog/psychoterapia-psychodynamiczna/index.svelte').then(m => m.default)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/blog/psychoterapia-psychodynamiczna"
        },
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": true,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/blog/roznice-miedzy-psychologia-psychiatria-a-psychoterapia/index",
              "id": "_blog_rozniceMiedzyPsychologiaPsychiatriaAPsychoterapia_index",
              "component": () => import('../../../../src/pages/blog/roznice-miedzy-psychologia-psychiatria-a-psychoterapia/index.svelte').then(m => m.default)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/blog/roznice-miedzy-psychologia-psychiatria-a-psychoterapia"
        },
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": true,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/blog/znaczenie-snu-dla-zdrowia-psychicznego/index",
              "id": "_blog_znaczenieSnuDlaZdrowiaPsychicznego_index",
              "component": () => import('../../../../src/pages/blog/znaczenie-snu-dla-zdrowia-psychicznego/index.svelte').then(m => m.default)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/blog/znaczenie-snu-dla-zdrowia-psychicznego"
        }
      ],
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/blog"
    },
    {
      "isFile": false,
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": true,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/cennik/index",
              "id": "_bydgoszcz_cennik_index",
              "component": () => import('../../../../src/pages/bydgoszcz/cennik/index.svelte').then(m => m.default)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/bydgoszcz/cennik"
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": true,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/bydgoszcz/index",
          "id": "_bydgoszcz_index",
          "component": () => import('../../../../src/pages/bydgoszcz/index.svelte').then(m => m.default)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/bydgoszcz/kontakt",
          "id": "_bydgoszcz_kontakt",
          "component": () => import('../../../../src/pages/bydgoszcz/kontakt.svelte').then(m => m.default)
        },
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/uslugi/badanie-funkcji-poznawczych",
              "id": "_bydgoszcz_uslugi_badanieFunkcjiPoznawczych",
              "component": () => import('../../../../src/pages/bydgoszcz/uslugi/badanie-funkcji-poznawczych.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/uslugi/badanie-osobowosci",
              "id": "_bydgoszcz_uslugi_badanieOsobowosci",
              "component": () => import('../../../../src/pages/bydgoszcz/uslugi/badanie-osobowosci.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/uslugi/badanie-poziomu-intelektu",
              "id": "_bydgoszcz_uslugi_badaniePoziomuIntelektu",
              "component": () => import('../../../../src/pages/bydgoszcz/uslugi/badanie-poziomu-intelektu.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/uslugi/grupa-profilaktyczno-terapeutyczna-dla-mlodziezy",
              "id": "_bydgoszcz_uslugi_grupaProfilaktycznoTerapeutycznaDlaMlodziezy",
              "component": () => import('../../../../src/pages/bydgoszcz/uslugi/grupa-profilaktyczno-terapeutyczna-dla-mlodziezy.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/uslugi/grupa-terapeutyczna-w-nurcie-gestalt-dla-doroslych",
              "id": "_bydgoszcz_uslugi_grupaTerapeutycznaWNurcieGestaltDlaDoroslych",
              "component": () => import('../../../../src/pages/bydgoszcz/uslugi/grupa-terapeutyczna-w-nurcie-gestalt-dla-doroslych.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/uslugi/grupa-terapeutyczno-rozwojowa-dla-doroslych",
              "id": "_bydgoszcz_uslugi_grupaTerapeutycznoRozwojowaDlaDoroslych",
              "component": () => import('../../../../src/pages/bydgoszcz/uslugi/grupa-terapeutyczno-rozwojowa-dla-doroslych.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/uslugi/grupa-terapeutyczno-rozwojowa-dla-mlodziezy",
              "id": "_bydgoszcz_uslugi_grupaTerapeutycznoRozwojowaDlaMlodziezy",
              "component": () => import('../../../../src/pages/bydgoszcz/uslugi/grupa-terapeutyczno-rozwojowa-dla-mlodziezy.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/uslugi/grupa-terapeutyczno-rozwojowa-dla-nastolatkow",
              "id": "_bydgoszcz_uslugi_grupaTerapeutycznoRozwojowaDlaNastolatkow",
              "component": () => import('../../../../src/pages/bydgoszcz/uslugi/grupa-terapeutyczno-rozwojowa-dla-nastolatkow.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": true,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/uslugi/index",
              "id": "_bydgoszcz_uslugi_index",
              "component": () => import('../../../../src/pages/bydgoszcz/uslugi/index.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/uslugi/interwencja-kryzysowa",
              "id": "_bydgoszcz_uslugi_interwencjaKryzysowa",
              "component": () => import('../../../../src/pages/bydgoszcz/uslugi/interwencja-kryzysowa.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/uslugi/otwarta-grupa-wsparcia-w-nurcie-gestalt-dla-doroslych",
              "id": "_bydgoszcz_uslugi_otwartaGrupaWsparciaWNurcieGestaltDlaDoroslych",
              "component": () => import('../../../../src/pages/bydgoszcz/uslugi/otwarta-grupa-wsparcia-w-nurcie-gestalt-dla-doroslych.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/uslugi/psychiatra-bydgoszcz-konsultacje-osob-doroslych",
              "id": "_bydgoszcz_uslugi_psychiatraBydgoszczKonsultacjeOsobDoroslych",
              "component": () => import('../../../../src/pages/bydgoszcz/uslugi/psychiatra-bydgoszcz-konsultacje-osob-doroslych.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/uslugi/psychiatra-dzieci-i-mlodziezy",
              "id": "_bydgoszcz_uslugi_psychiatraDzieciIMlodziezy",
              "component": () => import('../../../../src/pages/bydgoszcz/uslugi/psychiatra-dzieci-i-mlodziezy.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/uslugi/psychogeriatra-psychiatra-osob-starszych",
              "id": "_bydgoszcz_uslugi_psychogeriatraPsychiatraOsobStarszych",
              "component": () => import('../../../../src/pages/bydgoszcz/uslugi/psychogeriatra-psychiatra-osob-starszych.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/uslugi/psycholog",
              "id": "_bydgoszcz_uslugi_psycholog",
              "component": () => import('../../../../src/pages/bydgoszcz/uslugi/psycholog.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/uslugi/psychoterapia",
              "id": "_bydgoszcz_uslugi_psychoterapia",
              "component": () => import('../../../../src/pages/bydgoszcz/uslugi/psychoterapia.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/uslugi/psychoterapia-dzieci-i-mlodziezy",
              "id": "_bydgoszcz_uslugi_psychoterapiaDzieciIMlodziezy",
              "component": () => import('../../../../src/pages/bydgoszcz/uslugi/psychoterapia-dzieci-i-mlodziezy.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/uslugi/psychoterapia-systemowa",
              "id": "_bydgoszcz_uslugi_psychoterapiaSystemowa",
              "component": () => import('../../../../src/pages/bydgoszcz/uslugi/psychoterapia-systemowa.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/uslugi/seksuolog",
              "id": "_bydgoszcz_uslugi_seksuolog",
              "component": () => import('../../../../src/pages/bydgoszcz/uslugi/seksuolog.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/uslugi/terapia-dzieci-i-mlodziezy-konsultacje-dla-rodzicow",
              "id": "_bydgoszcz_uslugi_terapiaDzieciIMlodziezyKonsultacjeDlaRodzicow",
              "component": () => import('../../../../src/pages/bydgoszcz/uslugi/terapia-dzieci-i-mlodziezy-konsultacje-dla-rodzicow.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/uslugi/terapia-emdr",
              "id": "_bydgoszcz_uslugi_terapiaEmdr",
              "component": () => import('../../../../src/pages/bydgoszcz/uslugi/terapia-emdr.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/uslugi/terapia-par",
              "id": "_bydgoszcz_uslugi_terapiaPar",
              "component": () => import('../../../../src/pages/bydgoszcz/uslugi/terapia-par.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/uslugi/terapia-rodzinna",
              "id": "_bydgoszcz_uslugi_terapiaRodzinna",
              "component": () => import('../../../../src/pages/bydgoszcz/uslugi/terapia-rodzinna.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/uslugi/trening-umiejetnosci-spolecznych",
              "id": "_bydgoszcz_uslugi_treningUmiejetnosciSpolecznych",
              "component": () => import('../../../../src/pages/bydgoszcz/uslugi/trening-umiejetnosci-spolecznych.svelte').then(m => m.default)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/bydgoszcz/uslugi"
        },
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/zespol/psychiatra-dzieci-i-mlodziezy-janina-malkowska",
              "id": "_bydgoszcz_zespol_psychiatraDzieciIMlodziezyJaninaMalkowska",
              "component": () => import('../../../../src/pages/bydgoszcz/zespol/psychiatra-dzieci-i-mlodziezy-janina-malkowska.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/zespol/psychiatra-ecaterina-cocetcova",
              "id": "_bydgoszcz_zespol_psychiatraEcaterinaCocetcova",
              "component": () => import('../../../../src/pages/bydgoszcz/zespol/psychiatra-ecaterina-cocetcova.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/zespol/psychiatra-katarzyna-wolska",
              "id": "_bydgoszcz_zespol_psychiatraKatarzynaWolska",
              "component": () => import('../../../../src/pages/bydgoszcz/zespol/psychiatra-katarzyna-wolska.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/zespol/psychiatra-rezydent-mikolaj-klosowski",
              "id": "_bydgoszcz_zespol_psychiatraRezydentMikolajKlosowski",
              "component": () => import('../../../../src/pages/bydgoszcz/zespol/psychiatra-rezydent-mikolaj-klosowski.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/zespol/psychiatra-rezydent-mikolaj-rak",
              "id": "_bydgoszcz_zespol_psychiatraRezydentMikolajRak",
              "component": () => import('../../../../src/pages/bydgoszcz/zespol/psychiatra-rezydent-mikolaj-rak.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/zespol/psycholog-magdalena-waszak",
              "id": "_bydgoszcz_zespol_psychologMagdalenaWaszak",
              "component": () => import('../../../../src/pages/bydgoszcz/zespol/psycholog-magdalena-waszak.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/zespol/psycholog-pedagog-psychoterapeuta-joanna-krzyzanowska",
              "id": "_bydgoszcz_zespol_psychologPedagogPsychoterapeutaJoannaKrzyzanowska",
              "component": () => import('../../../../src/pages/bydgoszcz/zespol/psycholog-pedagog-psychoterapeuta-joanna-krzyzanowska.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/zespol/psycholog-pedagog-zofia-kurowska",
              "id": "_bydgoszcz_zespol_psychologPedagogZofiaKurowska",
              "component": () => import('../../../../src/pages/bydgoszcz/zespol/psycholog-pedagog-zofia-kurowska.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/zespol/psycholog-psychoterapeuta-anna-lobocka",
              "id": "_bydgoszcz_zespol_psychologPsychoterapeutaAnnaLobocka",
              "component": () => import('../../../../src/pages/bydgoszcz/zespol/psycholog-psychoterapeuta-anna-lobocka.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/zespol/psycholog-psychoterapeuta-anna-wroblewska-czerniak",
              "id": "_bydgoszcz_zespol_psychologPsychoterapeutaAnnaWroblewskaCzerniak",
              "component": () => import('../../../../src/pages/bydgoszcz/zespol/psycholog-psychoterapeuta-anna-wroblewska-czerniak.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/zespol/psycholog-psychoterapeuta-dorota-kuffel",
              "id": "_bydgoszcz_zespol_psychologPsychoterapeutaDorotaKuffel",
              "component": () => import('../../../../src/pages/bydgoszcz/zespol/psycholog-psychoterapeuta-dorota-kuffel.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/zespol/psycholog-psychoterapeuta-ewa-kotecka",
              "id": "_bydgoszcz_zespol_psychologPsychoterapeutaEwaKotecka",
              "component": () => import('../../../../src/pages/bydgoszcz/zespol/psycholog-psychoterapeuta-ewa-kotecka.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/zespol/psycholog-psychoterapeuta-karolina-kasprzak",
              "id": "_bydgoszcz_zespol_psychologPsychoterapeutaKarolinaKasprzak",
              "component": () => import('../../../../src/pages/bydgoszcz/zespol/psycholog-psychoterapeuta-karolina-kasprzak.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/zespol/psycholog-psychoterapeuta-kinga-iwanska",
              "id": "_bydgoszcz_zespol_psychologPsychoterapeutaKingaIwanska",
              "component": () => import('../../../../src/pages/bydgoszcz/zespol/psycholog-psychoterapeuta-kinga-iwanska.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/zespol/psychoterapeuta-psychodynamiczny-agnieszka-dajnowska",
              "id": "_bydgoszcz_zespol_psychoterapeutaPsychodynamicznyAgnieszkaDajnowska",
              "component": () => import('../../../../src/pages/bydgoszcz/zespol/psychoterapeuta-psychodynamiczny-agnieszka-dajnowska.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/zespol/psychoterapeuta-psycholog-pedagog-joanna-maciejewska",
              "id": "_bydgoszcz_zespol_psychoterapeutaPsychologPedagogJoannaMaciejewska",
              "component": () => import('../../../../src/pages/bydgoszcz/zespol/psychoterapeuta-psycholog-pedagog-joanna-maciejewska.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/bydgoszcz/zespol/psychoterapeutka-karolina-waligora",
              "id": "_bydgoszcz_zespol_psychoterapeutkaKarolinaWaligora",
              "component": () => import('../../../../src/pages/bydgoszcz/zespol/psychoterapeutka-karolina-waligora.svelte').then(m => m.default)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/bydgoszcz/zespol"
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/bydgoszcz/zespol",
          "id": "_bydgoszcz_zespol",
          "component": () => import('../../../../src/pages/bydgoszcz/zespol.svelte').then(m => m.default)
        }
      ],
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/bydgoszcz"
    },
    {
      "isFile": false,
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": true,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/do-pobrania/index",
          "id": "_doPobrania_index",
          "component": () => import('../../../../src/pages/do-pobrania/index.svelte').then(m => m.default)
        }
      ],
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/do-pobrania"
    },
    {
      "isFile": true,
      "isDir": false,
      "ext": "svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": true,
      "isFallback": false,
      "isPage": true,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/index",
      "id": "_index",
      "component": () => import('../../../../src/pages/index.svelte').then(m => m.default)
    },
    {
      "isFile": false,
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": true,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/kontakt/index",
          "id": "_kontakt_index",
          "component": () => import('../../../../src/pages/kontakt/index.svelte').then(m => m.default)
        }
      ],
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/kontakt"
    },
    {
      "isFile": false,
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": true,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/oferty-pracy/index",
          "id": "_ofertyPracy_index",
          "component": () => import('../../../../src/pages/oferty-pracy/index.svelte').then(m => m.default)
        }
      ],
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/oferty-pracy"
    },
    {
      "isFile": true,
      "isDir": false,
      "ext": "svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": true,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/regulamin",
      "id": "_regulamin",
      "component": () => import('../../../../src/pages/regulamin.svelte').then(m => m.default)
    },
    {
      "isFile": false,
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": true,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/cennik/index",
              "id": "_torun_cennik_index",
              "component": () => import('../../../../src/pages/torun/cennik/index.svelte').then(m => m.default)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/torun/cennik"
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": true,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/torun/index",
          "id": "_torun_index",
          "component": () => import('../../../../src/pages/torun/index.svelte').then(m => m.default)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/torun/kontakt",
          "id": "_torun_kontakt",
          "component": () => import('../../../../src/pages/torun/kontakt.svelte').then(m => m.default)
        },
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/uslugi/badanie-funkcji-poznawczych",
              "id": "_torun_uslugi_badanieFunkcjiPoznawczych",
              "component": () => import('../../../../src/pages/torun/uslugi/badanie-funkcji-poznawczych.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/uslugi/badanie-osobowosci",
              "id": "_torun_uslugi_badanieOsobowosci",
              "component": () => import('../../../../src/pages/torun/uslugi/badanie-osobowosci.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/uslugi/badanie-poziomu-intelektu",
              "id": "_torun_uslugi_badaniePoziomuIntelektu",
              "component": () => import('../../../../src/pages/torun/uslugi/badanie-poziomu-intelektu.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/uslugi/diagnostyka-adhd",
              "id": "_torun_uslugi_diagnostykaAdhd",
              "component": () => import('../../../../src/pages/torun/uslugi/diagnostyka-adhd.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/uslugi/diagnostyka-asd",
              "id": "_torun_uslugi_diagnostykaAsd",
              "component": () => import('../../../../src/pages/torun/uslugi/diagnostyka-asd.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/uslugi/diagnostyka-autyzmu",
              "id": "_torun_uslugi_diagnostykaAutyzmu",
              "component": () => import('../../../../src/pages/torun/uslugi/diagnostyka-autyzmu.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/uslugi/grupa-dla-mlodych-doroslych",
              "id": "_torun_uslugi_grupaDlaMlodychDoroslych",
              "component": () => import('../../../../src/pages/torun/uslugi/grupa-dla-mlodych-doroslych.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/uslugi/grupa-rozwojowa-terapeutyczna-dla-kobiet",
              "id": "_torun_uslugi_grupaRozwojowaTerapeutycznaDlaKobiet",
              "component": () => import('../../../../src/pages/torun/uslugi/grupa-rozwojowa-terapeutyczna-dla-kobiet.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/uslugi/grupa-terapeutyczno-rozwojowa-dla-doroslych",
              "id": "_torun_uslugi_grupaTerapeutycznoRozwojowaDlaDoroslych",
              "component": () => import('../../../../src/pages/torun/uslugi/grupa-terapeutyczno-rozwojowa-dla-doroslych.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/uslugi/grupa-terapeutyczno-rozwojowa-dla-mlodziezy",
              "id": "_torun_uslugi_grupaTerapeutycznoRozwojowaDlaMlodziezy",
              "component": () => import('../../../../src/pages/torun/uslugi/grupa-terapeutyczno-rozwojowa-dla-mlodziezy.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/uslugi/grupa-wsparcia-dla-kobiet-samotnych-porzuconych-po-stracie",
              "id": "_torun_uslugi_grupaWsparciaDlaKobietSamotnychPorzuconychPoStracie",
              "component": () => import('../../../../src/pages/torun/uslugi/grupa-wsparcia-dla-kobiet-samotnych-porzuconych-po-stracie.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": true,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/uslugi/index",
              "id": "_torun_uslugi_index",
              "component": () => import('../../../../src/pages/torun/uslugi/index.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/uslugi/interwencja-kryzysowa",
              "id": "_torun_uslugi_interwencjaKryzysowa",
              "component": () => import('../../../../src/pages/torun/uslugi/interwencja-kryzysowa.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/uslugi/psychiatra-dzieci-i-mlodziezy",
              "id": "_torun_uslugi_psychiatraDzieciIMlodziezy",
              "component": () => import('../../../../src/pages/torun/uslugi/psychiatra-dzieci-i-mlodziezy.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/uslugi/psychiatra-torun-konsultacje-osob-doroslych",
              "id": "_torun_uslugi_psychiatraTorunKonsultacjeOsobDoroslych",
              "component": () => import('../../../../src/pages/torun/uslugi/psychiatra-torun-konsultacje-osob-doroslych.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/uslugi/psychogeriatra-psychiatra-osob-starszych",
              "id": "_torun_uslugi_psychogeriatraPsychiatraOsobStarszych",
              "component": () => import('../../../../src/pages/torun/uslugi/psychogeriatra-psychiatra-osob-starszych.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/uslugi/psycholog",
              "id": "_torun_uslugi_psycholog",
              "component": () => import('../../../../src/pages/torun/uslugi/psycholog.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/uslugi/psychoterapia",
              "id": "_torun_uslugi_psychoterapia",
              "component": () => import('../../../../src/pages/torun/uslugi/psychoterapia.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/uslugi/psychoterapia-dzieci-i-mlodziezy",
              "id": "_torun_uslugi_psychoterapiaDzieciIMlodziezy",
              "component": () => import('../../../../src/pages/torun/uslugi/psychoterapia-dzieci-i-mlodziezy.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/uslugi/psychoterapia-systemowa",
              "id": "_torun_uslugi_psychoterapiaSystemowa",
              "component": () => import('../../../../src/pages/torun/uslugi/psychoterapia-systemowa.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/uslugi/seksuolog",
              "id": "_torun_uslugi_seksuolog",
              "component": () => import('../../../../src/pages/torun/uslugi/seksuolog.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/uslugi/terapia-dzieci-i-mlodziezy-konsultacje-dla-rodzicow",
              "id": "_torun_uslugi_terapiaDzieciIMlodziezyKonsultacjeDlaRodzicow",
              "component": () => import('../../../../src/pages/torun/uslugi/terapia-dzieci-i-mlodziezy-konsultacje-dla-rodzicow.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/uslugi/terapia-emdr",
              "id": "_torun_uslugi_terapiaEmdr",
              "component": () => import('../../../../src/pages/torun/uslugi/terapia-emdr.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/uslugi/terapia-par",
              "id": "_torun_uslugi_terapiaPar",
              "component": () => import('../../../../src/pages/torun/uslugi/terapia-par.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/uslugi/terapia-rodzinna",
              "id": "_torun_uslugi_terapiaRodzinna",
              "component": () => import('../../../../src/pages/torun/uslugi/terapia-rodzinna.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/uslugi/trening-umiejetnosci-spolecznych",
              "id": "_torun_uslugi_treningUmiejetnosciSpolecznych",
              "component": () => import('../../../../src/pages/torun/uslugi/trening-umiejetnosci-spolecznych.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/uslugi/warsztaty-dla-rodzicow",
              "id": "_torun_uslugi_warsztatyDlaRodzicow",
              "component": () => import('../../../../src/pages/torun/uslugi/warsztaty-dla-rodzicow.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/uslugi/warsztaty-profilaktyczno-terapeutyczne-dla-mlodziezy",
              "id": "_torun_uslugi_warsztatyProfilaktycznoTerapeutyczneDlaMlodziezy",
              "component": () => import('../../../../src/pages/torun/uslugi/warsztaty-profilaktyczno-terapeutyczne-dla-mlodziezy.svelte').then(m => m.default)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/torun/uslugi"
        },
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/anna-janiszewska-psychiatra",
              "id": "_torun_zespol_annaJaniszewskaPsychiatra",
              "component": () => import('../../../../src/pages/torun/zespol/anna-janiszewska-psychiatra.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/dominika-chylinska-psychiatra",
              "id": "_torun_zespol_dominikaChylinskaPsychiatra",
              "component": () => import('../../../../src/pages/torun/zespol/dominika-chylinska-psychiatra.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/gabriela-janiszewska",
              "id": "_torun_zespol_gabrielaJaniszewska",
              "component": () => import('../../../../src/pages/torun/zespol/gabriela-janiszewska.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/krzysztof-rosa",
              "id": "_torun_zespol_krzysztofRosa",
              "component": () => import('../../../../src/pages/torun/zespol/krzysztof-rosa.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/pedagog-psychoterapeuta-natalia-sarnowska",
              "id": "_torun_zespol_pedagogPsychoterapeutaNataliaSarnowska",
              "component": () => import('../../../../src/pages/torun/zespol/pedagog-psychoterapeuta-natalia-sarnowska.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psychiatra-dzieci-i-mlodziezy-dagmara-raca-piekarz",
              "id": "_torun_zespol_psychiatraDzieciIMlodziezyDagmaraRacaPiekarz",
              "component": () => import('../../../../src/pages/torun/zespol/psychiatra-dzieci-i-mlodziezy-dagmara-raca-piekarz.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psychiatra-dzieci-i-mlodziezy-pawel-radziejewski",
              "id": "_torun_zespol_psychiatraDzieciIMlodziezyPawelRadziejewski",
              "component": () => import('../../../../src/pages/torun/zespol/psychiatra-dzieci-i-mlodziezy-pawel-radziejewski.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psychiatra-dzieciecy-agata-mccarthy",
              "id": "_torun_zespol_psychiatraDzieciecyAgataMccarthy",
              "component": () => import('../../../../src/pages/torun/zespol/psychiatra-dzieciecy-agata-mccarthy.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psychiatra-ecaterina-cocetcova",
              "id": "_torun_zespol_psychiatraEcaterinaCocetcova",
              "component": () => import('../../../../src/pages/torun/zespol/psychiatra-ecaterina-cocetcova.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psychiatra-magda-bazan",
              "id": "_torun_zespol_psychiatraMagdaBazan",
              "component": () => import('../../../../src/pages/torun/zespol/psychiatra-magda-bazan.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psychiatra-malgorzata-opara",
              "id": "_torun_zespol_psychiatraMalgorzataOpara",
              "component": () => import('../../../../src/pages/torun/zespol/psychiatra-malgorzata-opara.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psychiatra-malgorzata-starczewska",
              "id": "_torun_zespol_psychiatraMalgorzataStarczewska",
              "component": () => import('../../../../src/pages/torun/zespol/psychiatra-malgorzata-starczewska.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psychiatra-marta-andracka",
              "id": "_torun_zespol_psychiatraMartaAndracka",
              "component": () => import('../../../../src/pages/torun/zespol/psychiatra-marta-andracka.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psychiatra-mateusz-maternia",
              "id": "_torun_zespol_psychiatraMateuszMaternia",
              "component": () => import('../../../../src/pages/torun/zespol/psychiatra-mateusz-maternia.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psychiatra-patrycja-sawicka-czarniak",
              "id": "_torun_zespol_psychiatraPatrycjaSawickaCzarniak",
              "component": () => import('../../../../src/pages/torun/zespol/psychiatra-patrycja-sawicka-czarniak.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psychiatra-patryk-centek",
              "id": "_torun_zespol_psychiatraPatrykCentek",
              "component": () => import('../../../../src/pages/torun/zespol/psychiatra-patryk-centek.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psychiatra-tomasz-bett",
              "id": "_torun_zespol_psychiatraTomaszBett",
              "component": () => import('../../../../src/pages/torun/zespol/psychiatra-tomasz-bett.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psychiatra-urszula-szulc",
              "id": "_torun_zespol_psychiatraUrszulaSzulc",
              "component": () => import('../../../../src/pages/torun/zespol/psychiatra-urszula-szulc.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psycholog-agnieszka-farbiszewska",
              "id": "_torun_zespol_psychologAgnieszkaFarbiszewska",
              "component": () => import('../../../../src/pages/torun/zespol/psycholog-agnieszka-farbiszewska.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psycholog-aleksandra-trzcinska",
              "id": "_torun_zespol_psychologAleksandraTrzcinska",
              "component": () => import('../../../../src/pages/torun/zespol/psycholog-aleksandra-trzcinska.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psycholog-aneta-stawiszynska-biarda",
              "id": "_torun_zespol_psychologAnetaStawiszynskaBiarda",
              "component": () => import('../../../../src/pages/torun/zespol/psycholog-aneta-stawiszynska-biarda.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psycholog-biznesu-psychoterapeuta-alina-matlakiewicz",
              "id": "_torun_zespol_psychologBiznesuPsychoterapeutaAlinaMatlakiewicz",
              "component": () => import('../../../../src/pages/torun/zespol/psycholog-biznesu-psychoterapeuta-alina-matlakiewicz.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psycholog-dzieciecy-agnieszka-guminska",
              "id": "_torun_zespol_psychologDzieciecyAgnieszkaGuminska",
              "component": () => import('../../../../src/pages/torun/zespol/psycholog-dzieciecy-agnieszka-guminska.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psycholog-katarzyna-lietz",
              "id": "_torun_zespol_psychologKatarzynaLietz",
              "component": () => import('../../../../src/pages/torun/zespol/psycholog-katarzyna-lietz.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psycholog-malgorzata-solska",
              "id": "_torun_zespol_psychologMalgorzataSolska",
              "component": () => import('../../../../src/pages/torun/zespol/psycholog-malgorzata-solska.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psycholog-miroslawa-jakubowska",
              "id": "_torun_zespol_psychologMiroslawaJakubowska",
              "component": () => import('../../../../src/pages/torun/zespol/psycholog-miroslawa-jakubowska.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psycholog-psychoterapeuta-agata-stark",
              "id": "_torun_zespol_psychologPsychoterapeutaAgataStark",
              "component": () => import('../../../../src/pages/torun/zespol/psycholog-psychoterapeuta-agata-stark.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psycholog-psychoterapeuta-anna-chwialkowska-dabkowska",
              "id": "_torun_zespol_psychologPsychoterapeutaAnnaChwialkowskaDabkowska",
              "component": () => import('../../../../src/pages/torun/zespol/psycholog-psychoterapeuta-anna-chwialkowska-dabkowska.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psycholog-psychoterapeuta-dymitr-leszko",
              "id": "_torun_zespol_psychologPsychoterapeutaDymitrLeszko",
              "component": () => import('../../../../src/pages/torun/zespol/psycholog-psychoterapeuta-dymitr-leszko.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psycholog-psychoterapeuta-magdalena-dabrowska",
              "id": "_torun_zespol_psychologPsychoterapeutaMagdalenaDabrowska",
              "component": () => import('../../../../src/pages/torun/zespol/psycholog-psychoterapeuta-magdalena-dabrowska.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psycholog-psychoterapeuta-magdalena-fajkowska",
              "id": "_torun_zespol_psychologPsychoterapeutaMagdalenaFajkowska",
              "component": () => import('../../../../src/pages/torun/zespol/psycholog-psychoterapeuta-magdalena-fajkowska.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psycholog-psychoterapeuta-malgorzata-rzymyszkiewicz",
              "id": "_torun_zespol_psychologPsychoterapeutaMalgorzataRzymyszkiewicz",
              "component": () => import('../../../../src/pages/torun/zespol/psycholog-psychoterapeuta-malgorzata-rzymyszkiewicz.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psycholog-psychoterapeuta-natalia-jarek",
              "id": "_torun_zespol_psychologPsychoterapeutaNataliaJarek",
              "component": () => import('../../../../src/pages/torun/zespol/psycholog-psychoterapeuta-natalia-jarek.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psycholog-psychoterapeuta-psychotraumatolog-elzbieta-kuleszko",
              "id": "_torun_zespol_psychologPsychoterapeutaPsychotraumatologElzbietaKuleszko",
              "component": () => import('../../../../src/pages/torun/zespol/psycholog-psychoterapeuta-psychotraumatolog-elzbieta-kuleszko.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psycholog-psychoterapeuta-systemowy-aleksander-jachowski",
              "id": "_torun_zespol_psychologPsychoterapeutaSystemowyAleksanderJachowski",
              "component": () => import('../../../../src/pages/torun/zespol/psycholog-psychoterapeuta-systemowy-aleksander-jachowski.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psychoterapeuta-dominika-kalabinska",
              "id": "_torun_zespol_psychoterapeutaDominikaKalabinska",
              "component": () => import('../../../../src/pages/torun/zespol/psychoterapeuta-dominika-kalabinska.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psychoterapeuta-jagoda-gajewska",
              "id": "_torun_zespol_psychoterapeutaJagodaGajewska",
              "component": () => import('../../../../src/pages/torun/zespol/psychoterapeuta-jagoda-gajewska.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psychoterapeuta-joanna-roch",
              "id": "_torun_zespol_psychoterapeutaJoannaRoch",
              "component": () => import('../../../../src/pages/torun/zespol/psychoterapeuta-joanna-roch.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psychoterapeuta-joanna-wisniewska",
              "id": "_torun_zespol_psychoterapeutaJoannaWisniewska",
              "component": () => import('../../../../src/pages/torun/zespol/psychoterapeuta-joanna-wisniewska.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psychoterapeuta-magdalena-kruczynska",
              "id": "_torun_zespol_psychoterapeutaMagdalenaKruczynska",
              "component": () => import('../../../../src/pages/torun/zespol/psychoterapeuta-magdalena-kruczynska.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psychoterapeuta-magdalena-smorowska",
              "id": "_torun_zespol_psychoterapeutaMagdalenaSmorowska",
              "component": () => import('../../../../src/pages/torun/zespol/psychoterapeuta-magdalena-smorowska.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psychoterapeuta-marcin-orlowski",
              "id": "_torun_zespol_psychoterapeutaMarcinOrlowski",
              "component": () => import('../../../../src/pages/torun/zespol/psychoterapeuta-marcin-orlowski.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/psychoterapeuta-pawel-murawski",
              "id": "_torun_zespol_psychoterapeutaPawelMurawski",
              "component": () => import('../../../../src/pages/torun/zespol/psychoterapeuta-pawel-murawski.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/seksuolog-psychoterapeuta-marta-malecka",
              "id": "_torun_zespol_seksuologPsychoterapeutaMartaMalecka",
              "component": () => import('../../../../src/pages/torun/zespol/seksuolog-psychoterapeuta-marta-malecka.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/torun/zespol/terapeuta-rodzinny-sylwia-trafna-jurkiewicz",
              "id": "_torun_zespol_terapeutaRodzinnySylwiaTrafnaJurkiewicz",
              "component": () => import('../../../../src/pages/torun/zespol/terapeuta-rodzinny-sylwia-trafna-jurkiewicz.svelte').then(m => m.default)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/torun/zespol"
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/torun/zespol",
          "id": "_torun_zespol",
          "component": () => import('../../../../src/pages/torun/zespol.svelte').then(m => m.default)
        }
      ],
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/torun"
    },
    {
      "isFile": false,
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/badanie-funkcji-poznawczych",
          "id": "_uslugi_badanieFunkcjiPoznawczych",
          "component": () => import('../../../../src/pages/uslugi/badanie-funkcji-poznawczych.svelte').then(m => m.default)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/badanie-osobowosci",
          "id": "_uslugi_badanieOsobowosci",
          "component": () => import('../../../../src/pages/uslugi/badanie-osobowosci.svelte').then(m => m.default)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/badanie-poziomu-intelektu",
          "id": "_uslugi_badaniePoziomuIntelektu",
          "component": () => import('../../../../src/pages/uslugi/badanie-poziomu-intelektu.svelte').then(m => m.default)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/diagnostyka-adhd",
          "id": "_uslugi_diagnostykaAdhd",
          "component": () => import('../../../../src/pages/uslugi/diagnostyka-adhd.svelte').then(m => m.default)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/diagnostyka-asd",
          "id": "_uslugi_diagnostykaAsd",
          "component": () => import('../../../../src/pages/uslugi/diagnostyka-asd.svelte').then(m => m.default)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/diagnostyka-autyzmu",
          "id": "_uslugi_diagnostykaAutyzmu",
          "component": () => import('../../../../src/pages/uslugi/diagnostyka-autyzmu.svelte').then(m => m.default)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/grupa-dla-mlodych-doroslych",
          "id": "_uslugi_grupaDlaMlodychDoroslych",
          "component": () => import('../../../../src/pages/uslugi/grupa-dla-mlodych-doroslych.svelte').then(m => m.default)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/grupa-profilaktyczno-terapeutyczna-dla-mlodziezy",
          "id": "_uslugi_grupaProfilaktycznoTerapeutycznaDlaMlodziezy",
          "component": () => import('../../../../src/pages/uslugi/grupa-profilaktyczno-terapeutyczna-dla-mlodziezy.svelte').then(m => m.default)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/grupa-rozwojowa-terapeutyczna-dla-kobiet",
          "id": "_uslugi_grupaRozwojowaTerapeutycznaDlaKobiet",
          "component": () => import('../../../../src/pages/uslugi/grupa-rozwojowa-terapeutyczna-dla-kobiet.svelte').then(m => m.default)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/grupa-terapeutyczna-w-nurcie-gestalt-dla-doroslych",
          "id": "_uslugi_grupaTerapeutycznaWNurcieGestaltDlaDoroslych",
          "component": () => import('../../../../src/pages/uslugi/grupa-terapeutyczna-w-nurcie-gestalt-dla-doroslych.svelte').then(m => m.default)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/grupa-terapeutyczno-rozwojowa-dla-doroslych",
          "id": "_uslugi_grupaTerapeutycznoRozwojowaDlaDoroslych",
          "component": () => import('../../../../src/pages/uslugi/grupa-terapeutyczno-rozwojowa-dla-doroslych.svelte').then(m => m.default)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/grupa-terapeutyczno-rozwojowa-dla-mlodziezy",
          "id": "_uslugi_grupaTerapeutycznoRozwojowaDlaMlodziezy",
          "component": () => import('../../../../src/pages/uslugi/grupa-terapeutyczno-rozwojowa-dla-mlodziezy.svelte').then(m => m.default)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/grupa-wsparcia-dla-kobiet-samotnych-porzuconych-po-stracie",
          "id": "_uslugi_grupaWsparciaDlaKobietSamotnychPorzuconychPoStracie",
          "component": () => import('../../../../src/pages/uslugi/grupa-wsparcia-dla-kobiet-samotnych-porzuconych-po-stracie.svelte').then(m => m.default)
        },
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/uslugi/grupa-wsparcia-osob-z-doswiadczeniem-przemocy/torun",
              "id": "_uslugi_grupaWsparciaOsobZDoswiadczeniemPrzemocy_torun",
              "component": () => import('../../../../src/pages/uslugi/grupa-wsparcia-osob-z-doswiadczeniem-przemocy/torun.svelte').then(m => m.default)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/grupa-wsparcia-osob-z-doswiadczeniem-przemocy"
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": true,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/index",
          "id": "_uslugi_index",
          "component": () => import('../../../../src/pages/uslugi/index.svelte').then(m => m.default)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/interwencja-kryzysowa",
          "id": "_uslugi_interwencjaKryzysowa",
          "component": () => import('../../../../src/pages/uslugi/interwencja-kryzysowa.svelte').then(m => m.default)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/otwarta-grupa-wsparcia-w-nurcie-gestalt-dla-doroslych",
          "id": "_uslugi_otwartaGrupaWsparciaWNurcieGestaltDlaDoroslych",
          "component": () => import('../../../../src/pages/uslugi/otwarta-grupa-wsparcia-w-nurcie-gestalt-dla-doroslych.svelte').then(m => m.default)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/psychiatra-dzieci-i-mlodziezy",
          "id": "_uslugi_psychiatraDzieciIMlodziezy",
          "component": () => import('../../../../src/pages/uslugi/psychiatra-dzieci-i-mlodziezy.svelte').then(m => m.default)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/psychiatra-konsultacje-osob-doroslych",
          "id": "_uslugi_psychiatraKonsultacjeOsobDoroslych",
          "component": () => import('../../../../src/pages/uslugi/psychiatra-konsultacje-osob-doroslych.svelte').then(m => m.default)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/psychogeriatra-psychiatra-osob-starszych",
          "id": "_uslugi_psychogeriatraPsychiatraOsobStarszych",
          "component": () => import('../../../../src/pages/uslugi/psychogeriatra-psychiatra-osob-starszych.svelte').then(m => m.default)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/psycholog",
          "id": "_uslugi_psycholog",
          "component": () => import('../../../../src/pages/uslugi/psycholog.svelte').then(m => m.default)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/psychoterapia",
          "id": "_uslugi_psychoterapia",
          "component": () => import('../../../../src/pages/uslugi/psychoterapia.svelte').then(m => m.default)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/psychoterapia-dzieci-i-mlodziezy",
          "id": "_uslugi_psychoterapiaDzieciIMlodziezy",
          "component": () => import('../../../../src/pages/uslugi/psychoterapia-dzieci-i-mlodziezy.svelte').then(m => m.default)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/psychoterapia-systemowa",
          "id": "_uslugi_psychoterapiaSystemowa",
          "component": () => import('../../../../src/pages/uslugi/psychoterapia-systemowa.svelte').then(m => m.default)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/seksuolog",
          "id": "_uslugi_seksuolog",
          "component": () => import('../../../../src/pages/uslugi/seksuolog.svelte').then(m => m.default)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/terapia-dzieci-i-mlodziezy-konsultacje-dla-rodzicow",
          "id": "_uslugi_terapiaDzieciIMlodziezyKonsultacjeDlaRodzicow",
          "component": () => import('../../../../src/pages/uslugi/terapia-dzieci-i-mlodziezy-konsultacje-dla-rodzicow.svelte').then(m => m.default)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/terapia-emdr",
          "id": "_uslugi_terapiaEmdr",
          "component": () => import('../../../../src/pages/uslugi/terapia-emdr.svelte').then(m => m.default)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/terapia-par",
          "id": "_uslugi_terapiaPar",
          "component": () => import('../../../../src/pages/uslugi/terapia-par.svelte').then(m => m.default)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/terapia-rodzinna",
          "id": "_uslugi_terapiaRodzinna",
          "component": () => import('../../../../src/pages/uslugi/terapia-rodzinna.svelte').then(m => m.default)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/trening-umiejetnosci-spolecznych",
          "id": "_uslugi_treningUmiejetnosciSpolecznych",
          "component": () => import('../../../../src/pages/uslugi/trening-umiejetnosci-spolecznych.svelte').then(m => m.default)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/warsztaty-dla-rodzicow",
          "id": "_uslugi_warsztatyDlaRodzicow",
          "component": () => import('../../../../src/pages/uslugi/warsztaty-dla-rodzicow.svelte').then(m => m.default)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/warsztaty-profilaktyczno-terapeutyczne-dla-mlodziezy",
          "id": "_uslugi_warsztatyProfilaktycznoTerapeutyczneDlaMlodziezy",
          "component": () => import('../../../../src/pages/uslugi/warsztaty-profilaktyczno-terapeutyczne-dla-mlodziezy.svelte').then(m => m.default)
        },
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/uslugi/warsztaty-spotkanie-z-bajka-terapeutyczna/torun",
              "id": "_uslugi_warsztatySpotkanieZBajkaTerapeutyczna_torun",
              "component": () => import('../../../../src/pages/uslugi/warsztaty-spotkanie-z-bajka-terapeutyczna/torun.svelte').then(m => m.default)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/uslugi/warsztaty-spotkanie-z-bajka-terapeutyczna"
        }
      ],
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/uslugi"
    },
    {
      "isFile": false,
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": true,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/wizyta/index",
          "id": "_wizyta_index",
          "component": () => import('../../../../src/pages/wizyta/index.svelte').then(m => m.default)
        }
      ],
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/wizyta"
    },
    {
      "isFile": false,
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": true,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/wspolpraca/index",
          "id": "_wspolpraca_index",
          "component": () => import('../../../../src/pages/wspolpraca/index.svelte').then(m => m.default)
        }
      ],
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/wspolpraca"
    },
    {
      "isFile": false,
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/zespol/paulina-szymanska",
          "id": "_zespol_paulinaSzymanska",
          "component": () => import('../../../../src/pages/zespol/paulina-szymanska.svelte').then(m => m.default)
        },
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/zespol/psycholog-anna-mizgajska-wodkowska/torun",
              "id": "_zespol_psychologAnnaMizgajskaWodkowska_torun",
              "component": () => import('../../../../src/pages/zespol/psycholog-anna-mizgajska-wodkowska/torun.svelte').then(m => m.default)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/zespol/psycholog-anna-mizgajska-wodkowska"
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/zespol/psycholog-psychodietetyk-psychoterapeuta-malgorzata-domanska",
          "id": "_zespol_psychologPsychodietetykPsychoterapeutaMalgorzataDomanska",
          "component": () => import('../../../../src/pages/zespol/psycholog-psychodietetyk-psychoterapeuta-malgorzata-domanska.svelte').then(m => m.default)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/zespol/psychoterapeuta-ewa-matuszewska",
          "id": "_zespol_psychoterapeutaEwaMatuszewska",
          "component": () => import('../../../../src/pages/zespol/psychoterapeuta-ewa-matuszewska.svelte').then(m => m.default)
        }
      ],
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/zespol"
    },
    {
      "isFile": true,
      "isDir": false,
      "ext": "svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": true,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/zespol",
      "id": "_zespol",
      "component": () => import('../../../../src/pages/zespol.svelte').then(m => m.default)
    }
  ],
  "isLayout": false,
  "isReset": false,
  "isIndex": false,
  "isFallback": false,
  "meta": {
    "preload": false,
    "prerender": true,
    "precache-order": false,
    "precache-proximity": true,
    "recursive": true
  },
  "path": "/"
}


export const {tree, routes} = buildClientTree(_tree)

